var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGloopImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.353516,
    y: 0.489258,
    width: 62.677,
    height: 59.7025,
    rx: 8,
    fill: "#19FB80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5297 20.2288C40.7205 19.8495 39.5028 19.8435 39.3628 19.8435L38.2221 19.8481C37.775 19.8498 37.3761 20.1296 37.2221 20.5493L33.6761 30.2163L30.3037 39.4099C30.0476 40.108 30.5643 40.8479 31.3079 40.8479H48.0402C48.657 40.8479 49.1505 40.3262 49.0542 39.717C48.5935 36.802 47.0805 34.2361 44.9153 32.422C44.3839 31.9768 43.5982 32.2375 43.3639 32.8899L42.4515 35.4298H37.5355L39.5871 29.834L41.1811 25.4889C41.6673 25.5762 42.1459 25.6861 42.617 25.8185C44.8374 26.4649 47.8317 27.8572 50.421 30.8651C50.8046 31.3106 51.4693 31.4065 51.9395 31.0537L54.575 29.0764C55.0453 28.7236 55.1447 28.0554 54.7723 27.6005C51.6392 23.7736 47.3205 21.1883 42.5297 20.2288Z",
    fill: "#1F2623"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9029 40.4614C22.7121 40.8407 23.9298 40.8467 24.0698 40.8467L25.2105 40.8421C25.6577 40.8403 26.0565 40.5606 26.2105 40.1408L29.7565 30.4739L33.1289 21.2803C33.385 20.5822 32.8683 19.8423 32.1247 19.8423L15.3924 19.8423C14.7756 19.8423 14.2822 20.364 14.3784 20.9732C14.8391 23.8882 16.3521 26.4541 18.5173 28.2682C19.0487 28.7134 19.8344 28.4527 20.0688 27.8002L20.9811 25.2604L25.8971 25.2604L23.8455 30.8562L22.2515 35.2013C21.7654 35.114 21.2867 35.0041 20.8156 34.8716C18.5953 34.2253 15.601 32.833 13.0116 29.8251C12.628 29.3796 11.9633 29.2837 11.4931 29.6364L8.85759 31.6138C8.38734 31.9666 8.28793 32.6348 8.66035 33.0897C11.7934 36.9166 16.1121 39.5019 20.9029 40.4614Z",
    fill: "#1F2623"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGloopImg1);
export default __webpack_public_path__ + "static/media/gloop_img1.ea34cbc6a686ce00538eed2debde880c.svg";
export { ForwardRef as ReactComponent };